<template>
	<page>
		<listTemplate page-title="About Us" :pid="'1751802774693203970'" type="detail"></listTemplate>
	</page>
</template>

<script>
	import listTemplate from "~/components/entemplate/listTemplate.vue";

	export default {
		components: {
			listTemplate
		},
		data() {
			return {
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/english/TravelInfo/AboutUs.vue